const loc_de_strings = {
    "Login": {
        "HEADING": "Login FOLBB-ID Plattform",
        "LOGIN": "Login",
        "USER": "Benutzer",
        "PASSWORD": "Passwort",
        "LOGIN_FAIL": "Login fehlgeschlagen",
        "LOGIN_FIELD_REQUIRED": "Der \"Benutzername\" ist ein Pflichtfeld",
        "PASSWORD_FIELD_REQUIRED": "Das \"Passwort\" ist ein Pflichtfeld",
        "FORGOT_PASSWORD": "Passwort vergessen?",
        "DIFFERENT_ACCOUNT": "Melden Sie sich mit einem anderen Account an",
        "NO_ACCOUNT": "Kein Account?",
        "REGISTER": "Registrieren Sie sich bei FOLBB digital",
        "CHANGE_DENIED_TEXT": "Bitte verwenden sie z.B. OWA um Ihr AD-Passwort zu ändern, oder kontaktieren Sie Ihren Support."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Dashboard",
        "ACTION_TEXT": "Aktionen",
        "CHANGE_PASSWORD_TEXT": "Passwort ändern",
        "MY_APPLICATIONS_TEXT": "Meine FOLBB-Anwendungen",
        "APPLICATIONS_TEXT": "FOLBB-Anwendungen",
        "USERS_LIST_TEXT": "Benutzerverwaltung"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Dashboard",
        "MY_APPLICATIONS_TEXT": "Meine FOLBB-Anwendungen",
        "APPLICATIONS_TEXT": "FOLBB-Anwendungen"
    },
    "Header": {
        "USER_MENU_TEXT": "Benutzermenü",
        "ACTION_TEXT": "Aktionen",
        "CHANGE_PASSWORD_TEXT": "Passwort ändern",
        "USERS_LIST_TEXT": "Benutzerverwaltung",
        "USER_GROUPS": "Rollen"
    },
    "Credentials": {
        "OLD_PASSWORD": "Passwort",
        "NEW_PASSWORD": "Neues Passwort",
        "CONFIRM_PASSWORD": "Passwort bestätigen",
        "PASS_DO_NOT_MATCH": "Die Passwörter stimmen nicht überein",
        "PASSWORD_FIELD_REQUIRED": "Das \"Neue Passwort\" ist ein Pflichtfeld",
        "OLD_PASSWORD_FIELD_REQUIRED": "Das \"Alte Passwort\" ist ein Pflichtfeld",
        "SUCCESS_TEXT": "Das Passwort wurde erfolgreich geändert",
        "HEADING": "FOLBB-ID ändern der Anmeldeinformationen",
        "HELP": "Brauche Hilfe?",
        "SAVE": "Speichern",
        "CANCEL": "Abbrechen",
        "PASSWORD_CHANGE_ERROR": "Das Passwort kann jetzt nicht geändert werden. Bitte versuchen sie es später erneut",
        "PASSWORD_CHANGE_LINK_EXPIRED": "Der Passwort zurücksetzen Link ist entweder ungültig, oder abgelaufen. Bitte senden sie sich den Link nochmals.",
        "PASSWORD_STREIGHT_ERROR": "Das Passwort sollte mindestens 10 Symbole enthalten, darunter untere, obere, Sonderzeichen, Ziffern und Unicode",
        "PASSWORD_REQUIREMENTS_TEXT": "Das Passwort muss die folgenden Kriterien erfüllen:",
        "LOWERCASE_LETTER_TEXT": "Mindestens 1 Kleinbuchstabe",
        "UPPERCASE_LETTER_TEXT": "Mindestens 1 Großbuchstabe",
        "NUMBER_TEXT": "Mindestens 1 Zahl",
        "SPECIAL_SYMBOL_TEXT": "Mindestens 1 Sonderzeichen",
        "PASSWORD_LENGTH_TEXT": "Mindestlänge 10 Zeichen",
        "PASSWORD_RESTRICTION_TEXT": "Der Vor-, Nach-, oder Benutzername darf nicht Teil des Passwortes sein",
        "CHANGE_PASSWORD_TEXT": "Passwort ändern",
        "ACTION_TEXT": "Aktionen",
        "CHANGE_DENIED_TEXT": "Bitte verwenden Sie z.B. OWA um Ihr AD-Passwort zu ändern, oder kontaktieren Sie Ihren Support."
    },
    "CreatePassword": {
        "PASSWORD": "Neues Passwort",
        "CONFIRM_PASSWORD": "Bestätigen Sie Ihr Passwort",
        "PASS_DO_NOT_MATCH": "Die Passwörter stimmen nicht überein",
        "PASSWORD_FIELD_REQUIRED": "Das \"Neue Passwort\" ist ein Pflichtfeld",
        "SUCCESS_TEXT": "Die Daten wurden erfolgreich gespeichert",
        "HEADING": "Passwort erstellen",
        "HELP": "Brauchen Sie Hilfe?",
        "SAVE": "Speichern",
        "CANCEL": "Abbrechen",
        "PASSWORD_CHANGE_ERROR": "Das Passwort kann jetzt nicht geändert werden. Bitte versuchen sie es später erneut",
        "PASSWORD_CHANGE_LINK_EXPIRED": "Der Passwort zurücksetzen Link ist entweder ungültig, oder abgelaufen. Bitte senden sie sich den Link nochmals.",
        "PASSWORD_STREIGHT_ERROR": "Das Passwort sollte mindestens 10 Symbole enthalten, darunter untere, obere, Sonderzeichen, Ziffern und Unicode",
        "PASSWORD_REQUIREMENTS_TEXT": "Das Passwort muss die folgenden Kriterien erfüllen:",
        "LOWERCASE_LETTER_TEXT": "Mindestens 1 Kleinbuchstabe",
        "UPPERCASE_LETTER_TEXT": "Mindestens 1 Großbuchstabe",
        "NUMBER_TEXT": "Mindestens 1 Zahl",
        "SPECIAL_SYMBOL_TEXT": "Mindestens 1 Sonderzeichen",
        "PASSWORD_LENGTH_TEXT": "Mindestlänge 10 Zeichen",
        "PASSWORD_RESTRICTION_TEXT": "Der Vor-, Nach-, oder Benutzername darf nicht Teil des Passwortes sein",
        "PASSWORD_WAS_SET": "Der Link zur Passwortvergabe wurde bereits verwendet. Wenn Sie Ihr Passwort nicht mehr wissen, benutzen Sie bitte die Passwort Reset Funktion.",
        "OLD_PASSWORD_REQUIRED": "Das \"Altes Passwort\" ist ein Pflichtfeld",
        "MMID_CHANGE_PASSWORD": "Passwort ändern",
        "OLD_PASSWORD": "Altes Passwort",
        "INVALID_OLD_PASSWORD": "Ungültiges altes Passwort",
        "USER_NOT_FOUND_OR_INACTIVE": "Benutzer nicht gefunden, oder inaktiv",
        "UNKNOWN_ERROR": "Es trat ein Fehler auf, das Passwort konnte nicht geändert werden"
    },
    "ForgotPassword": {
        "USER": "E-Mail",
        "LOGIN_FAIL": "Bitte geben Sie die korrekte E-Mail Adresse ein",
        "LOGIN_FIELD_REQUIRED": "Die \"E-mail Adresse\" ist ein Pflichtfeld",
        "HEADING": "Passwort vergessen",
        "HELP": "Brauchen Sie Hilfe?",
        "SAVE": "Reset Passwort E-Mail senden",
        "CANCEL": "Abbrechen",
        "SUCCESS_TEXT": "Bitte prüfen Sie, ob Sie eine E-Mail erhalten haben.",
        "CHANGE_DENIED_TEXT": "Bitte verwenden Sie z.B. OWA um Ihr AD-Passwort zu ändern, oder kontaktieren Sie Ihren Support.",
        "PASSWORD_RESET_TOO_OFTEN": "Die Passwort Reset Funktion wurde zu oft verwendet, bitte versuchen Sie es später",
        "RESET_FAILED": "Login fehlgeschlagen",
        "LINK_EXPIRED": "Der Link zum Zurücksetzen des Passworts ist abgelaufen. Bitte geben Sie Ihre Emailadresse ein, um Ihnen den Login Link erneut zusenden zu lassen.",
        "HEADING_EXPIRED": "Ihr Login Link ist abgelaufen",
        "SAVE_EXPIRED": "Login Link zusenden"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Benutzerverwaltung",
        "ACTIVE": "Aktiv",
        "INACTIVE": "Inaktiv",
        "MMID": "FOLBBID",
        "OU": "Organisationseinheit",
        "ORGANIZATION_UNIT": "Organisationseinheit",
        "LANGUAGE": "Sprache",
        "OPEN_FILTER": "Filter öffnen",
        "CLOSE_FILTER": "Filter schließen",
        "RESET": "Zurücksetzen",
        "RESET_ALL_FILTERS": "Alle Filter zurücksetzen",
        "SEARCH": "Suche",
        "STATUS": "Status",
        "GROUPS": "Gruppen",
        "SHOW_ALL_DETAILS": "Alle Details anzeigen",
        "SHOW_LESS": "Weniger Anzeigen",
        "ASCENDING": "Aufsteigend",
        "DESCENDING": "Absteigend",
        "LIST_END": "Ende der Liste",
        "SORT_BY_LASTNAME": "Nach Nachnamen sortieren",
        "SORT_BY_FIRSTNAME": "Nach Vornamen sortieren",
        "SORT_BY_EMAIL": "Nach E-Mail sortieren",
        "SORT_BY_LANGUAGE": "Nach bevorzugter Sprache sortieren",
        "SORT_BY_STATUS": "Nach Status sortieren",
        "SORT_BY_OU": "Nach Organisationseinheit sortieren",
        "SORT_BY_ACCOUNT_NAME": "Sortieren nach Logon Namen",
        "EDIT": "Bearbeiten",
        "CREATE": "Neuer Benutzer",
        "DIGICREATE": "Neuer FOLBB digital User",
        "ACTIVATE": "Aktivieren",
        "DEACTIVATE": "Deaktivieren",
        "USER_WAS_ACTIVATED": "Der Benutzer wurde aktiviert",
        "USER_WAS_DEACTIVATED": "Der Benutzer wurde deaktiviert",
        "ERROR_USER_ACTIVATION": "Fehler bei der Aktivierung",
        "ERROR_USER_DEACTIVATION": "Fehler bei der Deaktivierung",
        "SEND_FORGOT_PW_EMAIL": "Passwort vergessen E-Mail senden",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Generisches PW vergessen E-Mail",
        "SEND_FORGOT_PW_EMAIL_DIGI": "FOLBB digital PW vergessen E-Mail",
        "COMPANY": "Firma",
        "SEND_WELCOME_EMAIL": "Willkommens-E-Mail senden",
        "SEND_WELCOME_EMAIL_DIGI": "FOLBB digital Willkommens-E-Mail",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "FOLBB digital Willkommens-E-Mail ohne Button",
        "APPLY_FILTER_FOR_USERS": "Bitte verwenden Sie die Filter, oder die Suche, um die Ergebnisse anzuzeigen",
        "GENERATING_EMAIL": "E-Mail generieren ....",
        "ERROR_EMAIL_GENERATE": "Fehler beim Generieren der E-Mail ....",
        "LOCKED": "Gesperrt",
        "UNLOCK": "Entsperren",
        "SET_PASSWORD": "Passwort setzen",
        "PHYSICAL_LOCATION": "Lokation",
        "REQUIRED": "Pflichtfeld",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Benutzerverwaltung",
        "USER_WAS_ACTIVATED": "Der Benutzer wurde aktiviert",
        "USER_WAS_DEACTIVATED": "Der Benutzer wurde deaktiviert",
        "ERROR_USER_ACTIVATION": "Fehler bei der Aktivierung",
        "ERROR_USER_DEACTIVATION": "Fehler bei der Deaktivierung",
        "LOADING_USER_ERROR": "Fehler beim Laden des Benutzers",
        "FIRSTNAME": "Vorname",
        "LASTNAME": "Nachname",
        "EMAIL": "E-Mail",
        "ACCOUNT_NAME": "User Login-Name (pre-windows 2000)",
        "LANGUAGE": "Sprache",
        "PRINCIPAL_NAME": "User Principal name",
        "OU": "Organisationseinheit",
        "CLASS_DISPLAY_NAME": "Display name",
        "PHONE": "Telefon",
        "WEBSITE": "Website",
        "COUNTRY": "Land",
        "STATE": "Bundesland",
        "LOCATION": "Stadt",
        "STREET": "Straße",
        "POSTAL_CODE": "PLZ",
        "COMPANY": "Firma",
        "DEPARTMENT": "Abteilung",
        "PERSONAL_TITLE": "Titel",
        "MANAGER": "Manager",
        "DESCRIPTION": "Beschreibung",
        "GROUPS": "Gruppen",
        "SAVE": "Speichern",
        "CANCEL": "Abbrechen",
        "USER_STATUS": "Benutzerstatus",
        "ACTIVE": "Aktiv",
        "INACTIVE": "Inaktiv",
        "ACTIVATE": "Activate",
        "DEACTIVATE": "Deactivate",
        "USER_WAS_SAVED": "Der Benutzer wurde gespeichert. Das Serverupdate kann bis zu 60 sec dauern. <br/> Wenn sie alte Daten sehen, laden sie die Seite bitte alle 30 sec neu.",
        "UNKNOWN_ERROR": "Beim Speichern des Benutzers trat ein Fehler auf",
        "PROXY_ADDRESSES": "Proxy Adressen",
        "BROWSE": "Durchsuchen",
        "REMOVE": "Entfernen",
        "ONLY_JPG": "Es sind nur .jpg Bilder erlaubt!",
        "FILE_SIZE": "Die Dateigröße muss kleiner als 100KB sein!",
        "DIMENSIONS": "Die maximale Bilddimension ist 96x96 Pixel!",
        "SEND_FORGOT_PW_EMAIL": "Passwort vergessen E-Mail senden",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Generisches PW vergessen E-Mail",
        "SEND_FORGOT_PW_EMAIL_DIGI": "FOLBB digital Passwort vergessen E-Mail",
        "VIRUS_FOUND": "Der Benutzer wurde nicht gespeichert. Es wurde Malware im Anhang gefunden. Die Datei wurde nicht hochgeladen. Bitte kontaktieren Sie Ihren Systemadministrator.",
        "VIRUS_SCANNER_NOT_AVL": "Die Datei konnte nicht auf Malware überprüft werden. Bitte versuchen sSe es später erneut. Wenn das Problem besteht, kontaktieren Sie bitte Ihren Systemadministrator.",
        "INFO": "Info:",
        "SEND_WELCOME_EMAIL": "Willkommens-E-Mail senden",
        "SEND_WELCOME_EMAIL_DIGI": "FOLBB digital Willkommens-E-Mail",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "FOLBB digital Willkommens-E-Mail ohne Button",
        "SAVING_USER_SPINNER": "Speichere Benutzer... Bitte warten.",
        "DUPLICATE_USER": "Dieser Benutzer existiert bereits",
        "GENERATING_EMAIL": "E-Mail generieren ....",
        "ERROR_EMAIL_GENERATE": "Fehler beim Generieren der E-Mail ....",
        "UNLOCK": "Entsperren",
        "SET_PASSWORD": "Passwort setzen",
        "COST_CENTER": "Cost Center",
        "JOB_TITLE": "Jobtitel",
        "GENDER": "Geschlecht",
        "USER_NOT_FOUND": "Benutzer nicht gefunden",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Willkommens-E-Mail generieren ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Der Benutzer wurde aktiviert",
        "USER_WAS_DEACTIVATED": "Der Benutzer wurde deaktiviert",
        "ERROR_USER_ACTIVATION": "Fehler bei der Aktivierung",
        "ERROR_USER_DEACTIVATION": "Fehler bei der Deaktivierung",
        "EMAIL_WAS_SENT": "E-Mail wurde erfolgreich gesendet",
        "EMAIL_NOT_SENT_USER_ACTIVE": "E-Mail wurde nicht gesendet. Der Benutzer ist aktiv. Bitte verwenden Sie die Passwort vergessen E-Mail senden Funktion",
        "ERROR_EMAIL_SEND": "Fehler beim Versuch die E-Mail zu versenden",
        "EMAIL_NOT_SENT_USER_INACTIVE": "E-Mail wurde nicht gesendet. Der Benutzer ist inaktiv. Bitte verwenden Sie die FOLBB digital Registrierungs-E-Mail senden Funktion",
        "PASSWORD_RESET_TOO_OFTEN": "Die Passwort Reset Funktion wurde zu oft verwendet, bitte versuchen Sie es später",
        "USER_WAS_UNLOCKED": "Benutzer wurde entsperrt",
        "ERROR_UNLOCK_USER": "Fehler beim Entsperren des Benutzers"
    }
};

export default loc_de_strings;



// WEBPACK FOOTER //
// ./src/resources/de.js